import { memo } from 'react'

import { copy, LunyaAvatar } from '~/modules/lunya'
import { HStack, Text, ValueField, VStack } from '~/shared/ui'

import { BIRTH_DATE_FIELD_AVATAR_SIZE } from './config'
import { formatBirthDate } from '../../utils'
import type { BirthDateFieldProps } from './types'

/**
 * Дата рождения — единственное обязательное поле онбординга (спека 02 §A2),
 * поэтому оно крупнее и на `surface` с тенью, а не на `surface-alt`.
 */
export const BirthDateField = memo(function BirthDateField(props: BirthDateFieldProps) {
  const { value, errorText, isActive = false, onPress } = props
  const hasError = Boolean(errorText)

  return (
    <VStack gap='SMALL_S'>
      <ValueField
        label={copy.onb.a2.date}
        value={value ? formatBirthDate(value) : null}
        iconName='calendar'
        size='L'
        tone='PRIMARY'
        hasError={hasError}
        isActive={isActive}
        onPress={onPress}
      />

      {hasError && (
        <HStack gap='SMALL_M' align='CENTER'>
          <LunyaAvatar size={BIRTH_DATE_FIELD_AVATAR_SIZE} />
          <Text variant='BODY_S' color='ERROR_TEXT'>
            {errorText}
          </Text>
        </HStack>
      )}
    </VStack>
  )
})
